import { IOperator } from "api/types/_operator";
import { IRole } from "api/types/_role";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import TooltipCustom from "components/Common/TooltipCustom";
import { useRole } from "components/Hooks/UserHooks";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { ROLES_FOR_APP, isHavePermissionRole } from "helpers/role";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import TableContainer from "../../../components/Common/TableContainer";
import {
  deleteOperator,
  getAllRoles,
  getOperators as onGetOperators,
  putOperator,
} from "../../../store/thunks";
import OperatorForm from "./CreateForm";
import { formatDateStringToKorea } from "helpers/format";
import CopyWrapper from "components/Common/CopyWrapper";
import moment from "moment";
import DatePickerCustom from "components/Common/DatePickerCustom";
import CreateForm from "./CreateForm";

interface Option {
  label: string;
  value: string;
}

export interface Tag {
  id: string;
  text: string;
}

const TYPE_SELECT_DEFAULT: string = "id";

registerLocale("en", en);
registerLocale("ko", ko);

const RoleGroup = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();
  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    sort_by: withDefault(StringParam, ""),
    keyword: withDefault(StringParam, ""),
  });
  const [keywordSearch, setKeywordSearch] = useState<string>(
    query?.keyword || ""
  );

  const [mediasSearch, setMediasSearch] = useState<Option[]>([]);
  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [start_date, end_date] = dateSearch;

  const [userEdit, setUserEdit] = useState<
    (IOperator & { isCopy?: boolean }) | null
  >(null);

  const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [initialValuesDefault, setInitialValuesDefault] =
    useState<IOperator | null>(null);

  const [listRole, setListRole] = useState<IRole[]>([]);

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.Operator;

  const UserProperties = createSelector(selectLayoutState, (state) => ({
    operators: state.operators,
    isOperatorSuccess: state.isOperatorSuccess,
    isOperatorLoading: state.isOperatorLoading,
    error: state.error,
  }));

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // Inside your component
  const { operators, error, isOperatorLoading } = useSelector(UserProperties);

  useEffect(() => {
    // dispatch(onGetOperators(query));
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      keyword: encodeURIComponent(keywordSearch.trim()) || "",
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        keyword: "",
        sort_by: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setKeywordSearch((_prev) => "");
    setDateSearch([null, null]);
  };

  // Begin::Update User
  const onCloseClick = () => {
    setUserEdit((_prev) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    // dispatch(onGetOperators(query));
  };
  //End::Update User

  // Begin::Delete
  const handleConfirmDelete = (item: IOperator) => {
    setInitialValuesDefault((_prev) => item);
    setIsConfirm((_prev) => true);
  };

  const handleActionDelete = async () => {
    if (!initialValuesDefault?.id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await deleteOperator(initialValuesDefault?.id);
      if (response?.code === 200) {
        // dispatch(onGetOperators(query));
        setIsConfirmLoading((_prev) => false);
        setIsConfirm((_prev) => false);
        setInitialValuesDefault((_prev) => null);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmClick = () => {
    setInitialValuesDefault((_prev) => null);
    setIsConfirm((_prev) => false);
  };
  // End::Delete

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        thClass: "align-middle",
        Cell: ({ ...props }) => {
          const item = props?.row?.original;
          return (
            <CopyWrapper
              contentCopy={item?.id || ""}
              style={{ display: "inline-flex", minWidth: "50px" }}
            >
              <div>
                {operators?.pagination?.total -
                  ((query?.page - 1) * query?.limit + props?.row?.index)}
              </div>
            </CopyWrapper>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          return <div>{cell?.value || ""}</div>;
        },
      },
      {
        Header: t("Field EN"),
        accessor: "field_en",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          return <div>{cell?.value || ""}</div>;
        },
      },
      {
        Header: t("Field KR"),
        accessor: "field_kr",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          return <div>{cell?.value || ""}</div>;
        },
      },
      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 110,
        thClass: "text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value || "");
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 110,
        thClass: "text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value || "");
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Action"),
        thClass: "text-center",
        thWidth: 100,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0"
              style={{ minWidth: "70px" }}
            >
              {isHavePermissionRole(
                ROLES_FOR_APP.OPERATOR_UPDATE,
                userPermissions
              ) && (
                <TooltipCustom
                  title={t("Button Update Operator")}
                  id={`update-us-${item?.id}`}
                >
                  <li
                    className=" list-inline-item me-0"
                    id={`update-us-${item?.id}`}
                  >
                    <Link
                      className="btn btn-sm btn-soft-primary edit-item-btn"
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setUserEdit((prev) => item);
                      }}
                    >
                      <i className="ri-pencil-fill align-bottom"></i>
                    </Link>
                  </li>
                </TooltipCustom>
              )}
              {isHavePermissionRole(
                ROLES_FOR_APP.OPERATOR_DELETE,
                userPermissions
              ) && (
                <TooltipCustom
                  title={t("Button Delete Operator")}
                  id={`detail-cp-${item?.id}`}
                >
                  <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
                    <Link
                      className="btn btn-sm btn-soft-danger edit-item-btn"
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleConfirmDelete(item);
                      }}
                    >
                      <i className="ri-delete-bin-3-fill align-bottom"></i>
                    </Link>
                  </li>
                </TooltipCustom>
              )}
            </ul>
          );
        },
      },
    ],
    [i18n?.language, query, userPermissions, operators?.pagination?.total]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  const handleCallAllOption = async () => {
    try {
      const [resRole]: any = await Promise.all([getAllRoles()]);
      if (resRole?.data) {
        setListRole((_prev) => resRole?.data?.list);
      }
    } catch (error: any) {
      return error;
    }
  };

  const handleChangeStatusItem = async (item: any, status: boolean) => {
    try {
      const { email, fist_name, last_name, role_id } = structuredClone(item);
      const data = {
        email,
        fist_name,
        last_name,
        role_id,
        is_active: Number(status),
      };
      const response: any = await putOperator(item?.id, data);
      if (response?.data) {
        // dispatch(onGetOperators(query));
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t("Role Group")} - ${t("Home")} | ShowStar`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Role Group")} pageTitle={t("Home")} />
          <Row>
            {isHavePermissionRole(
              ROLES_FOR_APP.OPERATOR_LIST,
              userPermissions
            ) && (
              <Col lg={12}>
                <Card
                  id="customerList"
                  style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                >
                  <CardHeader className="border-0">
                    <Row className="g-4 align-items-center">
                      <div className="col-5 con-sm-6">
                        <div>
                          <h5 className="card-title mb-0">
                            <span className="me-2">{t("Total")}:</span>
                            <CountUp
                              start={0}
                              end={operators?.pagination?.total || 0}
                              duration={1}
                              className="text-primary"
                            />
                          </h5>
                        </div>
                      </div>
                      <div className="col-7 con-sm-6 text-end">
                        {isHavePermissionRole(
                          ROLES_FOR_APP.OPERATOR_CREATE,
                          userPermissions
                        ) && (
                          <div className="col-sm-auto">
                            <div>
                              <button
                                type="button"
                                className="btn btn-success add-btn rounded-pill"
                                id="create-btn"
                                onClick={() => setIsOpen((_prev) => true)}
                              >
                                <i className="ri-add-line align-bottom me-1"></i>
                                {t("Button Create Role Group")}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                    <Row className="g-4 align-items-center mt-0">
                      <Col
                        sm={6}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Keyword")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Keyword")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-2 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!start_date || !!end_date}
                        >
                          <DatePickerCustom
                            startDate={start_date || null}
                            endDate={end_date || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="hstack gap-1 justify-content-center justify-content-sm-start mt-3 mt-md-2"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-2 "
                            onClick={searchData}
                            disabled={isOperatorLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-3">
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle"
                      theadClass="table-light"
                      columns={columns}
                      data={operators?.list?.length ? operators?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={operators?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(operators?.pagination?.total) /
                          Number(operators?.pagination?.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isOperatorLoading}
                    />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
        <ToastContainer
          closeButton={false}
          newestOnTop={false}
          pauseOnFocusLoss
          autoClose={2000}
          limit={2}
        />
        <Modal isOpen={isOpen} centered={true} size="lg" scrollable={false}>
          <ModalHeader toggle={onCloseClick}>
            <>
              {!!itemToEdit?._id
                ? t("Button Update Role Group")
                : t("Button Create Role Group")}
            </>{" "}
            <>
              {itemToEdit?._id && (" - " + (itemToEdit?.nickname || "") || "")}
            </>
          </ModalHeader>
          <ModalBody>
            <div className="mt-1">
              <CreateForm
                id={String(itemToEdit?._id || "")}
                triggerRefresh={triggerRefresh}
                onClose={onCloseClick}
              />
            </div>
          </ModalBody>
        </Modal>
        <ModalConfirm
          header={t("Button Delete Operator")}
          isOpen={isOpenConfirm}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmClick}
          onConfirm={handleActionDelete}
        />
      </div>
    </React.Fragment>
  );
};

export default RoleGroup;
